"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const usePeopleSelectorStyle = () => {
    const theme = (0, material_1.useTheme)();
    const container = Object.assign(Object.assign({ width: '%100', height: '1.5rem', padding: '1rem 1.5rem', boxShadow: 'none' }, theme.qlub.typography.body_sm), { display: 'flex', justifyContent: 'space-between', alignItems: 'center' });
    const peopleStyle = {
        display: 'flex',
        alignItems: 'center',
        padding: '0',
        gap: '0.5 rem',
        position: 'relative',
        '& .circle': {
            color: theme.qlub.palette.iris_light.hover,
        },
        '& .person': {
            zIndex: 10,
            color: theme.qlub.palette.onSurfaceColors.highEmphasis,
            position: 'absolute',
            insetInlineStart: '2px',
            insetBlockStart: '1px',
        },
        '&>span': Object.assign({}, theme.qlub.typography.body_sm),
    };
    const selectorStyle = {
        display: 'flex',
        padding: '0',
        alignItems: 'center',
        gap: '0.5rem',
    };
    const spanStyle = Object.assign(Object.assign({}, theme.qlub.typography.body_sm), { color: theme.qlub.palette.onSurfaceColors.mediumEmphasis, width: '1.25rem', display: 'flex', justifyContent: 'center' });
    return {
        container,
        peopleStyle,
        spanStyle,
        selectorStyle,
    };
};
exports.default = usePeopleSelectorStyle;
